import { Divider } from "../catalyst"
import { ThemeToggle } from "../ThemeToggle"

export const DashboardLayout = ({ children }: { children: React.ReactNode }) => {
    return (
        <>
            < header className="h-14 flex justify-end items-center px-4" >
                <ThemeToggle />
            </header >
            <Divider />
            <main className="flex-1 h-full p-6 lg:p-10">
                {children}
            </main>
        </>
    )
}